import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

/** The hero — the top-of-page statement. Four structural variants over one component; that is where
 *  the creative range comes from without a second stylesheet per template. */
export const hero: BlockDef = {
  type: 'hero',
  v: 1,
  label: { en: 'Hero', ar: 'المقدّمة' },
  scope: 'page',
  fullOnly: true,
  description:
    'The prominent opening section of a page: a headline, a short supporting line, an optional image and one call-to-action.',
  whenToUse: 'The FIRST section of a landing or home page, to state what the business is in one sentence.',
  whenNotToUse:
    'For an ordinary content section further down the page — use a Text section, or a Heading followed by Text. Never more than one hero on a page.',
  variants: [
    { value: 'split', label: { en: 'Text beside image', ar: 'نص بجانب صورة' } },
    { value: 'centered', label: { en: 'Centred', ar: 'موسّط' } },
    { value: 'overlay', label: { en: 'Text over image', ar: 'نص فوق صورة' } },
    { value: 'minimal', label: { en: 'Minimal', ar: 'مبسّط' } },
  ],
  fields: [
    { key: 'heading', label: { en: 'Headline', ar: 'العنوان' }, type: { kind: 'text' }, default: EMPTY_TEXT, requiredForPublish: true },
    { key: 'subheading', label: { en: 'Supporting line', ar: 'سطر داعم' }, type: { kind: 'text' }, default: EMPTY_TEXT },
    {
      key: 'image',
      label: { en: 'Image', ar: 'الصورة' },
      type: { kind: 'image' },
      default: { status: 'placeholder', description: EMPTY_TEXT, orientation: 'landscape' },
    },
    { key: 'ctaLabel', label: { en: 'Button text', ar: 'نص الزر' }, type: { kind: 'text' }, default: EMPTY_TEXT, alongside: 'ctaLink' },
    { key: 'ctaLink', label: { en: 'Button goes to', ar: 'الزر ينتقل إلى' }, type: { kind: 'link' }, default: { kind: 'none' } },
    { key: 'background', label: { en: 'Background', ar: 'الخلفية' }, type: { kind: 'colorToken' }, scope: 'tmpl', default: 'brand' },
  ],
}
